import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import Layout from '../../layout/Layout';
import { accessKeys } from '../../statics/accessKeys';
import { accessCheck } from '../../utils/accessCheck';
import AccessTab from './Components/AccessTab';
import OrganizationTab from './Components/OrganizationTab';
import ProfileTab from './Components/ProfileTab';
import TeamList from './Components/TeamList';
import { checkDomain } from '../../utils/domainCheck.util';

const Settings = () => {
    const [searchParams, setSearchParams] = useSearchParams({ tab: "" });
    const [selectedTab, setSelectedTab] = useState(searchParams.get('tab') || 1);

    useEffect(() => {
        setSelectedTab(searchParams.get('tab') || 1)
        return () => {

        };
    }, [searchParams]);

    return (
        <Layout>
            <div className='flex items-center justify-between mb-1'>
                <p className='text-[17px] font-bold mb-0'>Settings</p>
            </div>
            <div className="flex items-center flex-wrap justify-center gap-3 px-2 py-1 bg-white rounded-lg max-w-fit mx-auto mb-3">
                <button onClick={() => { setSearchParams({ tab: 1 }, { replace: true }); setSelectedTab(1) }} className={`${selectedTab == 1 ? '!bg-primary text-white' : 'bg-transparent'} text-sm font-semibold px-5 py-1 rounded-lg`} >Profile</button>
                {/* <button onClick={() => setSelectedTab(2)} className={`${selectedTab == 2 ? '!bg-primary text-white' : 'bg-transparent'} text-sm font-semibold px-5 py-1 rounded-lg`}>Preferences</button> */}
                <button onClick={() => { setSearchParams({ tab: 2 }, { replace: true }); setSelectedTab(2) }} className={`${selectedTab == 2 ? '!bg-primary text-white' : 'bg-transparent'} text-sm font-semibold px-5 py-1 rounded-lg`}>Organizations</button>

                {!(!accessCheck(accessKeys?.updateTeamMemberStatus) && !accessCheck(accessKeys?.inviteMemberToOrganization) && !accessCheck(accessKeys?.viewTeamMembers)) && <button onClick={() => { setSearchParams({ tab: 3 }, { replace: true }); setSelectedTab(3) }} className={`${selectedTab == 3 ? '!bg-primary text-white' : 'bg-transparent'} text-sm font-semibold px-5 py-1 rounded-lg`}>Team</button>}

                {(accessCheck(accessKeys?.viewAccessPresets) && checkDomain() === "app") && <button onClick={() => { setSearchParams({ tab: 4 }, { replace: true }); setSelectedTab(4) }} className={`${selectedTab == 4 ? '!bg-primary text-white' : 'bg-transparent'} text-sm font-semibold px-5 py-1 rounded-lg`}>Access</button>}
            </div>

            {selectedTab == 1 && <ProfileTab />}

            {/* {  selectedTab == 2 && <PreferencesTab /> } */}

            {selectedTab == 2 && <div><OrganizationTab /></div>}

            {selectedTab == 3 && <div> <TeamList /> </div>}

            {selectedTab == 4 && <div> <AccessTab /> </div>}

        </Layout>
    )
}

export default Settings;